import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { CustomerOrderCancellationReportComponent } from './customer-order-cancellation-report.component';
import { JobsReportComponent } from './jobs-report.component';
import { NonMovementTransactionReportComponent } from './non-movement-transactions-report.component';
import { OrdersReportComponent } from './orders-report.component';
import { OrganisationReportComponent } from './organisation-report.component';
import { SupplierJobCancellationReportComponent } from './supplier-job-cancellation-report.component';
import { TasksReportComponent } from './tasks-report.component';
import { TransactionLinesReportComponent } from './transaction-lines-report.component';
import { SupplierUnassignmentReportComponent } from './supplierUnassignment/supplier-unassignment-report.component';
import { TableModule } from 'primeng/table';
import { OrdersReportBetaComponent } from './orders-report-beta.component';
import { DeclinedExpensesReportComponent } from './declined-expenses-report.component';
const routes: Routes = [
  {
    path: 'orders',
    component: OrdersReportComponent,
    data: { title: 'Orders Report' },
  },
  {
    path: 'ordersbeta',
    component: OrdersReportBetaComponent,
    data: { title: 'Orders Report Beta' },
  },
  {
    path: 'jobs',
    component: JobsReportComponent,
    data: { title: 'Jobs Report' },
  },
  {
    path: 'organisations',
    component: OrganisationReportComponent,
    data: { title: 'Supplier/Customer Data' },
  },
  {
    path: 'ordercancellation',
    component: CustomerOrderCancellationReportComponent,
    data: { title: 'Customer Order Cancellation' },
  },
  {
    path: 'jobcancellation',
    component: SupplierJobCancellationReportComponent,
    data: { title: 'Supplier Job Cancellation' },
  },
  {
    path: 'transactionlines',
    component: TransactionLinesReportComponent,
    data: { title: 'Movement Transaction Lines Report' },
  },
  {
    path: 'tasks',
    component: TasksReportComponent,
    data: { title: 'Tasks Report' },
  },
  {
    path: 'non-movement-transactions',
    component: NonMovementTransactionReportComponent,
    data: { title: 'Non-Movement Transactions Report' },
  },
  {
    path: 'supplierUnassignment',
    component: SupplierUnassignmentReportComponent,
    data: { title: 'Supplier Unassignment' },
  },
  {
    path: 'declined-expenses-report',
    component: DeclinedExpensesReportComponent,
    data: { title: 'Declined Expenses Report' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportRoutingModule {}

@NgModule({
  imports: [
    ReportRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    TableModule,
  ],
  declarations: [
    OrdersReportComponent,
    OrdersReportBetaComponent,
    JobsReportComponent,
    OrganisationReportComponent,
    CustomerOrderCancellationReportComponent,
    SupplierJobCancellationReportComponent,
    SupplierUnassignmentReportComponent,
    TransactionLinesReportComponent,
    TasksReportComponent,
    NonMovementTransactionReportComponent,
    DeclinedExpensesReportComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ReportModule {}
